import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';

export const tmpSelector = {
	selectMessage: createSelector(
		(state: RootState) => state.tmp.message,
		(res) => res,
	),
};
